// extracted by mini-css-extract-plugin
export default {"atcBtn":"ProductCard_atcBtn__tOh0B","title":"ProductCard_title__te-xa","stars":"ProductCard_stars__XKb57"};